export default __webpack_public_path__ + "static/media/car-2.b21da9d0.png";